export default __webpack_public_path__ + "static/media/logo.938f08ec.png";